<template>
  <div>
    <layout-head v-if="code==='001'" :navActive="2"></layout-head>
    <layout-head v-if="code==='002'" :navActive="4"></layout-head>
    <layout-head v-if="code==='003'" :navActive="1"></layout-head>
    <layout-head v-if="code!=='001' && code!=='002' && code!=='003'" :navActive="0"></layout-head>
    <div class="topic_details_container">
      <div class="warp12">
        <div class="topic_list_nav">
          <div class="bread">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item v-if="code==='001'" :to="{ path: '/multimedia' }">多媒体矩阵</el-breadcrumb-item>
              <el-breadcrumb-item v-if="code==='002'" :to="{ path: '/pictorialMatter' }">解图知事</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/topicDetails', query: { id:topicId, code: '001' }}">{{obj.fileName}}</el-breadcrumb-item>
              <el-breadcrumb-item>视频详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- <div class="search_container">
            <el-input v-model.trim="searText" placeholder="搜索你想知道的" @keyup.enter.native="checkList"></el-input>
            <img src="@/assets/image/index/search_btn.png" alt class="search_btn" @click="checkList" />
          </div> -->
        </div>
        <div class="video_container">
            <video :src="obj.videoUrl"
                width="100%"
                height="100%"
                controls
                controlslist="nodownload"
            >
            </video>
        </div>
        <div class="video_text">
            <h3 v-if="obj.fileName">{{ obj.fileName }}</h3>
            <p v-if="obj.brief">{{ obj.brief }}</p>
        </div>
      </div>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutHead from '@/components/Header'
import layoutFooter from '@/components/Footer'
import { getData } from '@/assets/js/api'
export default {
  name: 'topicDetailsPage',
  components: { layoutHead, layoutFooter },
  data () {
    return {
    //   searText: '',
      topicId: '',
      code: '',
      obj: {}
    }
  },
  watch: {
    $route: {
      handler (route) {
        this.topicId = this.$route.query.id
        this.code = '001'
        const params = {
          fileID: this.topicId,
          code: this.code
        }
        getData(params).then((res) => {
          if (res.code === '200') {
            this.obj = res.content.data[0]
          }
        })
      }
    }
  },
  created () {
    this.topicId = this.$route.query.id
    this.code = '001'
    const params = {
      fileID: this.topicId,
      code: this.code
    }
    getData(params).then((res) => {
      if (res.code === '200') {
        this.obj = res.content.data[0]
      }
    })
  },
  methods: {
    checkList () {
      this.$router.push({
        name: 'topic',
        query: {
          item: '全部',
          code: this.code,
          searText: this.searText
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.topic_details_container {
  margin-top: -387px;
  padding-bottom: 44px;
  .topic_list_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 26px;
    .bread {
    }
    .search_container {
      width: 342px;
      margin: 0;
    }
  }
  .video_container {
    width: 740px;
    height: 410px;
    margin: 0 auto;
    margin: 0 auto;
  }
  .video_text {
    width: 740px;
    margin: 40px auto;
    h3 {
    text-align: center;
    margin: 20px 0;
    color: #333333;
    }
    p {
        text-align: left;
        line-height: 1.8;
        color: #333333;
    }
  }

}
</style>
